import React, { useState } from 'react'
import { isMobile } from 'react-device-detect'

import {
  DcButton,
  DcOverlaySlider,
  DcSwitch,
  DcTabs,
  PixelDate,
  PixelDiv,
  PixelFactoryContext,
  PixelFlexBox,
  PixelModal,
  PixelPageContainer,
  Section,
  SectionActions,
  SectionContent,
  SectionHeader,
  SectionTitle,
} from 'pixel-base'
import { get, put } from 'utils/api-routes.util'
import ChangePasswordIcon from 'utils/icons/change-password-icon'
import CheckIcon from 'utils/icons/check-icon'
import PenIcon from 'utils/icons/pen-icon'
import XmarkIcon from 'utils/icons/xmark-icon'

import ChangePassword from './component/ChangePassword'
import EditUserInfo from './component/EditUserInfo'
import { IPixelFactory } from '../../../../../../decl.d'

const permissionTypes = [
  {
    id: 'store',
    name: 'Stores',
  },
  {
    id: 'courier',
    name: 'Couriers',
  },
  {
    id: 'warehouse',
    name: 'Warehouses',
  },
  {
    id: 'marketplace',
    name: 'Market Places',
  },
]

interface BPermission {
  active: boolean
  business_type: string
  id: string
  name: string
  permission: boolean
}
const UserDetails = (props: {
  userId: string
  setShowDetailModal: (show: boolean) => void
}) => {
  const { userId } = props
  const [user, setUser] = React.useState<any>({})
  const [entityPermission, setEntityPermission] = React.useState<BPermission[]>(
    [],
  )
  const permissionsRef = React.useRef(null)
  const userInfoRef = React.useRef(null)
  const { showLoader, hideLoader, showSuccess, showFailure } =
    React.useContext<IPixelFactory>(PixelFactoryContext)

  const [showNewModal, setShowNewModal] = React.useState(false)
  const [activePermission, setActivePermission] = useState('store')
  const [showChangePasswordModal, setShowChangePasswordModal] =
    React.useState(false)
  const [userRole, setUserRole] = React.useState([])
  const readData = () => {
    showLoader(userInfoRef)
    get(`/settings/users/${userId}`).subscribe((res: any) => {
      setUser(res.response.data)
      hideLoader(userInfoRef)
    })
  }

  const getUserPermissionsByType = (permission?) => {
    showLoader(permissionsRef)
    get(
      `/settings/users/${userId}/permissions/${
        permission ? permission : activePermission
      }`,
    ).subscribe((res: any) => {
      setEntityPermission(
        res.response.data.map((p: any) => {
          return {
            ...p,
            name: p.name
              ? p.name
              : p.store_name
              ? p.store_name
              : p.courier_name
              ? p.courier_name
              : p.warehouse_name,
            id: p.id
              ? p.id
              : p.store_id
              ? p.store_id
              : p.courier_id
              ? p.courier_id
              : p.warehouse_id,
            business_type: p.business_type
              ? p.business_type
              : p.store_type
              ? p.store_type
              : p.courier_company
              ? p.courier_company
              : p.warehouse_code,
          }
        }),
      )
      hideLoader(permissionsRef)
    })
  }

  const getAllUsersRole = () => {
    get('/settings/users/roles').subscribe((res: any) => {
      setUserRole(res.response.data)
    })
  }

  React.useEffect(() => {
    if (userId) readData()
    getAllUsersRole()
    getUserPermissionsByType()
  }, [])

  const changePermissions = (value, entity) => {
    showLoader(permissionsRef)
    const update_data = {
      id: entity['id'],
      enable: value ? 1 : 0,
      type: activePermission,
    }
    put(
      `/settings/users/${userId}/permissions/individual`,
      update_data,
    ).subscribe((res: any) => {
      hideLoader(permissionsRef)
      if (res && res.response.data) {
        setEntityPermission(
          entityPermission.map((item: any) => {
            if (item.id === update_data.id) {
              return {
                ...item,
                permission: !!update_data.enable,
              }
            }
            return item
          }),
        )
        showSuccess(res.response.data || res.response.data['message'])
      } else if (res && res.response['error']) {
        showFailure(res.response['error'])
      }
    })
  }
  const handleSetDataInEdit = (data) => {
    setShowNewModal(false)
    setUser(data)
  }
  const setPermission = (permission) => {
    setActivePermission(permission)
    getUserPermissionsByType(permission)
  }
  const tableDetailStyle = {
    width: '100%',
    display: 'table',
    tableLayout: 'fixed',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  }

  const identifierStyle = {
    fontSize: '16px',
    fontWeight: '600',
    color: '#8e959b',
    display: 'table-cell',
    verticalAlign: 'middle',
    // padding: '10px',
    width: '40%',
    // backgroundColor: '#e9ecef',
  }

  const detailStyle = {
    width: '60%',
    // backgroundColor: '#e9ecef78',
    fontSize: '16px',
    fontWeight: '400',
    color: '#8e959b',
    display: 'table-cell',
    verticalAlign: 'middle',
    paddingLeft: '10px',
  }

  return (
    <>
      <PixelPageContainer style={{ padding: '0px' }} isMobile={isMobile}>
        <Section isMobile={isMobile}>
          <SectionHeader>
            <SectionTitle>User Info</SectionTitle>
            <SectionActions>
              <DcButton
                style={{
                  marginRight: '10px',
                }}
                onClick={() => {
                  setShowNewModal(true)
                }}
                size="sm"
                withIcon={true}
              >
                <PenIcon size={16} />
                <span>Edit</span>
              </DcButton>
              <DcButton
                onClick={() => {
                  setShowChangePasswordModal(true)
                }}
                size="sm"
                withIcon={true}
              >
                <ChangePasswordIcon size={16} />
                <span>Change Password</span>
              </DcButton>
            </SectionActions>
          </SectionHeader>
          <SectionContent
            isMobile={isMobile}
            // className="p-0 user-info"
            // ref={userInfoRef}
          >
            <PixelDiv style={tableDetailStyle}>
              <PixelDiv style={identifierStyle}>Name:</PixelDiv>
              <PixelDiv style={detailStyle}>{user.name}</PixelDiv>
            </PixelDiv>

            <PixelDiv style={tableDetailStyle}>
              <PixelDiv style={identifierStyle}>Role:</PixelDiv>
              <PixelDiv style={detailStyle}>
                {user.user_type?.description}
              </PixelDiv>
            </PixelDiv>
            <PixelDiv style={tableDetailStyle}>
              <PixelDiv style={identifierStyle}>Email:</PixelDiv>
              <PixelDiv style={detailStyle}>{user.user_email}</PixelDiv>
            </PixelDiv>
            <PixelDiv style={tableDetailStyle}>
              <PixelDiv style={identifierStyle}>User Registered on:</PixelDiv>
              <PixelDiv style={detailStyle}>
                <PixelDate
                  color={'#8e959b'}
                  value={user.created_at?.date}
                  format={'dateWithTime'}
                />
              </PixelDiv>
            </PixelDiv>
            <PixelDiv style={tableDetailStyle}>
              <PixelDiv style={identifierStyle}>Account Status:</PixelDiv>
              <PixelDiv style={detailStyle}>
                {user.active ? (
                  <CheckIcon color="green" size={16} />
                ) : (
                  <XmarkIcon color="red" size={16} />
                )}
              </PixelDiv>
            </PixelDiv>
          </SectionContent>
        </Section>
        <Section style={{ padding: '20px' }} height={'50%'}>
          <SectionTitle>Permissions</SectionTitle>
          <DcTabs
            variant="pills"
            size="md"
            tabs={[...permissionTypes].map((types) => {
              return {
                label: types.name,
                value: types.id,
              }
            })}
            activeTab={activePermission}
            handleChange={(newPermisionType) => setPermission(newPermisionType)}
          />
          <SectionContent
            style={{
              overflow: 'auto',
              height: '50%',
              marginTop: '30px',
              maxHeight: 'calc(100vh - 440px)',
            }}
          >
            <PixelDiv>
              {entityPermission.map((item, index) => {
                return (
                  <PixelFlexBox
                    margin="0 0 10px 0"
                    flexDirection="row"
                    // justifyContent="space-between"
                    alignItems="center"
                    alignContent="center"
                    key={index}
                    gap="15px"
                  >
                    {' '}
                    <PixelDiv>
                      <DcSwitch
                        className={'large'}
                        onChange={(e) => {
                          changePermissions(e.target.checked, item)
                        }}
                        disabled={!item.active}
                        label={item.permission ? 'On' : 'Off'}
                        checked={item.permission}
                      />
                    </PixelDiv>
                    <PixelFlexBox
                      key={index}
                      // onClick={() => handleBoxClick(item)}
                      flexDirection="column"
                    >
                      <PixelDiv
                        style={{
                          fontSize: '14px',
                          fontWeight: '600',
                          marginBottom: '3px',
                          color: '#171717',
                        }}
                      >
                        {item.name}
                      </PixelDiv>
                      <PixelDiv
                        style={{
                          fontSize: '12px',
                          color: ' #999',
                          fontWeight: '300',
                          maxWidth: '80%',
                        }}
                      >
                        {item.business_type}
                      </PixelDiv>
                    </PixelFlexBox>
                  </PixelFlexBox>
                )
              })}
            </PixelDiv>
          </SectionContent>
        </Section>
      </PixelPageContainer>
      <DcOverlaySlider
        title={'Edit User Info'}
        onClose={() => setShowNewModal(false)}
        isOpen={showNewModal}
        width="50%"
      >
        <SectionContent>
          {showNewModal && (
            <EditUserInfo
              user={user}
              handleClose={handleSetDataInEdit}
              userRole={userRole}
            />
          )}
        </SectionContent>
      </DcOverlaySlider>
      <DcOverlaySlider
        title={'Change Password'}
        onClose={() => setShowChangePasswordModal(false)}
        isOpen={showChangePasswordModal}
        width="50%"
      >
        <SectionContent>
          {showChangePasswordModal && (
            <ChangePassword
              user={user}
              handleClose={() => setShowChangePasswordModal(false)}
            />
          )}
        </SectionContent>
      </DcOverlaySlider>
    </>
  )
}

export default UserDetails
